
export default {
    name: "PreviewTemplateAdvancedOption",
    props: {
        toolbar: { default: null, type: String, required: true },
    },
    computed: {
        toolbarComponent() {
            switch (this.toolbar) {
                case 'pdf':
                    return 'PreviewTemplateAdvancedOptionPdf';
                default:
                    return null;
                }
        }
    },
    components: {
        PreviewTemplateAdvancedOptionPdf: () => import(/* webpackChunkName: "PreviewTemplateAdvancedOptionPdf" */ "~/components/preview/PreviewTemplateAdvancedOptionPdf"),
    }
}
